import { ref, readonly } from "vue";
const checkIfIsFullscreen = () => window.outerHeight === screen.height;
const isFullscreen = ref(checkIfIsFullscreen());
window.addEventListener("resize", () => {
  isFullscreen.value = checkIfIsFullscreen();
});
function useIsFullscreen() {
  return readonly(isFullscreen);
}
const isFullscreenState = readonly(isFullscreen);
export {
  isFullscreenState,
  useIsFullscreen
};
//# sourceMappingURL=useIsFullscreen.mjs.map
